module.exports = __webpack_public_path__ + "img/m_img_truck@2x.3b351012.png";